import React from 'react';
import { IoColorPalette, IoResize, IoChevronForward } from 'react-icons/io5';
import styles from '../AddProduct.module.css';

function VariantsSection({
    checkvariation,
    setSelectva,
    setCheckvariation,
    setIsModalOpen,
    rows,
    rowsSize,
    productPage,
    setProductPage,
    errorFields,
    setErrorFields,
    handleFieldChange,
}) {
    return (
        <div className={styles['AddProduct-card']}>
            <h2 className={styles['AddProduct-card-title']}>Variants</h2>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Variation type
                </label>
                <select
                    name="variation"
                    value={checkvariation}
                    className={styles['AddProduct-category']}
                    onChange={(e) => {
                        setSelectva(e.target.value);
                        if (e.target.value === 'color') {
                            setCheckvariation('color');
                            setIsModalOpen(true);
                        } else if (e.target.value === 'colorSize') {
                            setCheckvariation('colorSize');
                            setIsModalOpen(true);
                        } else {
                            setCheckvariation('no');
                            setIsModalOpen(false);
                        }
                    }}
                >
                    <option value="no">No variants</option>
                    <option value="color">Color variants</option>
                    <option value="colorSize">Color and size variants</option>
                </select>
            </div>

            {(checkvariation === 'color' || checkvariation === 'colorSize') && (
                <div className={styles['AddProduct-form-group']}>
                    <button
                        type="button"
                        className={styles['AddProduct-manage-variants-button']}
                        onClick={() => setIsModalOpen(true)}
                    >
                        <span className={styles['manage-icon']}>
                            {checkvariation === 'color' ? (
                                <IoColorPalette />
                            ) : (
                                <IoResize />
                            )}
                        </span>
                        <div className={styles['manage-button-content']}>
                            <span className={styles['manage-button-title']}>
                                Manage{' '}
                                {checkvariation === 'color'
                                    ? 'Color'
                                    : 'Color & Size'}{' '}
                                Variants
                            </span>
                            <span className={styles['manage-button-subtitle']}>
                                {checkvariation === 'color'
                                    ? `${rows.length} variant${
                                          rows.length !== 1 ? 's' : ''
                                      } added`
                                    : `${rowsSize.length} color${
                                          rowsSize.length !== 1 ? 's' : ''
                                      } added`}
                            </span>
                        </div>
                        <span className={styles['manage-arrow']}>
                            <IoChevronForward />
                        </span>
                    </button>
                </div>
            )}

            {checkvariation === 'color' && (
                <div className={styles['AddProduct-form-group']}>
                    <label className={styles['AddProduct-label']}>
                        Product page layout
                    </label>
                    <select
                        name="productPage"
                        value={productPage}
                        className={styles['AddProduct-category']}
                        onChange={handleFieldChange(
                            'productPage',
                            setProductPage,
                            errorFields,
                            setErrorFields
                        )}
                    >
                        <option value="1">Standard layout</option>
                        <option value="2">Facebook-style scroll layout</option>
                    </select>
                </div>
            )}
        </div>
    );
}

export default VariantsSection;
